import React, { useEffect, useState } from 'react';

const AppUsageTracker = () => {
  const [startTime, setStartTime] = useState(Date.now());
  const [endTime, setEndTime] = useState(Date.now());
  const [timesCapture  , setTimesCapture] = useState([])
  const calculateAppUsageTime = () => {
    if (endTime) {
      const duration = endTime - startTime;
      const newTimeCapure = [...timesCapture , duration]
      setTimesCapture(newTimeCapure);
      setStartTime(Date.now());
      let totalTime = 0;
      newTimeCapure.forEach((val)=>{
        totalTime += val;
      })
      console.log(`App was used for ${totalTime} milliseconds.` , duration , 'added time');
        // alert(totalTime)

    }
  };
 
  useEffect(() => {
    const handleBeforeUnload = () => {
      setEndTime(Date.now());
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        setEndTime(Date.now());
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    calculateAppUsageTime();
  }, [endTime]);

  return ;
};

export default AppUsageTracker;
